module.exports = __webpack_public_path__ + "static/img/xiaohongshu.8ae99e6b.png";